import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown, faSun, faMoon, faMap, faGlobe } from '@fortawesome/free-solid-svg-icons'

library.add(faChevronDown, faSun, faMoon, faMap, faGlobe)

export { FontAwesomeIcon }
